<script>
    import AssetsApi from "../assets.api.js";
    import statisticService from "../../dashboard/service.js";
    import BreadCrumNav from "../../../components/breadcrum-nav.svelte";
    import List from "../_components/list.svelte";
    import { is_hostname_list, is_ip_list } from "../assets.api.js";
    import { notificate } from "../../../services/notification.js";
    import { assets, searchAssets } from "../assets.state.svelte.js";
    import Spinner from "../../../components/spinner.svelte";
    import { onMount, untrack } from "svelte";
    import {
        token,
        user,
        workspacePlan,
    } from "../../user/user.state.svelte.js";
    import tagService from "../../tag/service.js";
    import userService from "../../user/service.svelte.js";
    import { format, locale } from "svelte-i18n";
    import { params } from "@roxi/routify";

    let kind = $derived($params.kind);
    let isInitialLoading = $state(true);

    let tags = $state([]);
    let associations = $state([]);

    const getTags = async (config = { filter: {} }) => {
        if (!token.access_token) return [];
        return (tags = await tagService.search("v2/tag/", config));
    };

    const getTagAssociations = async () => {
        if (!token.access_token) return [];
        return (associations = await tagService.search("v2/tag/association/", {
            filter: { target_object_type: "Asset" },
        }));
    };

    const show_upgrade_plan_info = (kind) => {
        if (workspacePlan.data != "premium") {
            if (
                workspacePlan.data == "free" &&
                kind != "public_ip" &&
                kind != "domain" &&
                kind != "hostname"
            ) {
                return false;
            } else if (
                workspacePlan.data == "starter" &&
                (kind == "ad" ||
                    kind == "private_ip" ||
                    kind == "software" ||
                    kind == "cloud" ||
                    kind == "endpoint")
            ) {
                return false;
            } else if (
                workspacePlan.data == "standard" &&
                (kind == "ad" ||
                    kind == "software" ||
                    kind == "cloud" ||
                    kind == "endpoint")
            ) {
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    };

    let assetCountPromise = statisticService.countAssetByKind();
    let showed_assets_helper_message_once =
        user.data.showed_assets_helper_msg_once;
    let show_assets_helper_message = user.data.show_assets_helper_msg;

    $effect(async () => {
        untrack(async () => {
            if (!isInitialLoading) isInitialLoading = true;
        });
        if (kind) {
            await getTags();
            await getTagAssociations();
            untrack(async () => {
                if (!isInitialLoading) isInitialLoading = true;
                if (token.access_token) {
                    await searchAssets("v2/asset/", {
                        buildList: {
                            properties: true,
                            tags: {
                                elements: tags,
                                associations: associations,
                            },
                        },
                        filter: { kind: kind, include_finding_count: true },
                    });
                } else {
                    return [];
                }
            });
        }
        untrack(async () => {
            if (isInitialLoading) isInitialLoading = false;
        });
    });

    onMount(async () => {
        if (!isInitialLoading) isInitialLoading = true;
        let count = await assetCountPromise;
        if (
            kind &&
            ((is_ip_list(kind, true).public && !count.public_ip) ||
                (is_hostname_list(kind) && !count.hostname))
        ) {
            //show assets helper message might be undefined, != false check is needed.
            if (
                show_assets_helper_message != false &&
                !user.data.showed_assets_helper_msg_once
            ) {
                notificate("modal_assets_helper", "modal");
                let result = await notificate("modal_assets_helper", "modal");
                showed_assets_helper_message_once = true;
                if (result.value) {
                    userService
                        .saveLoggedUserSettings(
                            { key: "show_assets_helper_msg", value: false },
                            [],
                            { no_toaster: true },
                        )
                        .then(() => (show_assets_helper_message = false));
                }
            }
        }
    });

    let show_asset_info = $derived(show_upgrade_plan_info(kind));
</script>

{#if isInitialLoading}
    <div
        class="d-flex flex-column justify-content-center"
        style="height: 80vh;"
    >
        <Spinner />
    </div>
{:else}
    <section class="content-header">
        <div class="container-fluid">
            <div class="row">
                <div class="col-6">
                    <h1 class="mt-3 mb-3 page-title">
                        <i class={"fa-xs " + AssetsApi.AssetsIcons[kind]}></i>
                        {$format(`asset.kind.${kind}.plural`)}
                    </h1>
                </div>
                <div class="col-6">
                    <BreadCrumNav
                        routes={[
                            { label: $format(`asset.kind.${kind}.plural`) },
                        ]}
                    />
                </div>
            </div>
        </div>
    </section>

    {#if show_asset_info}
        <section class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        {#if assets.loading}
                            <div class="overlay-wrapper">
                                <div
                                    class="text-center"
                                    class:overlay={assets.loading}
                                >
                                    <i class="fas fa-2x fa-sync-alt fa-spin"
                                    ></i>
                                </div>
                            </div>
                        {/if}
                        {#key kind}
                            <List {tags} {kind} showActions={true} />
                        {/key}
                    </div>
                </div>
            </div>
        </section>
    {:else}
        <section class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="card-title">
                                    {$format("asset_kind")} no disponible
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="mt-3">
                                    Tu plan ({workspacePlan.data.toUpperCase()})
                                    no contempla los activos de este tipo.
                                </div>
                                <div class="mt-3">
                                    Para cambiar tu plan contactate con nosotros
                                    a nuestro correo electrónico <a
                                        href="mailto:vulseek@securetia.com"
                                        >vulseek@securetia.com</a
                                    >.
                                </div>
                                <div class="mt-3">
                                    Podés ver la información de los planes
                                    disponibles en <a
                                        href="https://www.securetia.com/vulseek.html"
                                        target="_blank"
                                        >https://www.securetia.com/vulseek.html</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    {/if}
{/if}

<style>
</style>
